import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute, UrlSegment, NavigationEnd } from '@angular/router';
import { TranslationService } from '../../core';

@Component({
	selector: 'sm-global-search',
	template: require('./sm-global-search.component.html')
})
export class SmGlobalSearchComponent {
	types: GlobalSearchType[] = [];
	active: GlobalSearchType;
	query: FormControl = new FormControl(null, [Validators.required, Validators.minLength(1)]);

	private _sub: any;

	constructor(
		translationService: TranslationService,
		private _router: Router
	) {
		let placeholder = translationService.getString('Co hledáte?');

		this.types = [
			{
				code: 'transactions',
				name: translationService.getString('v transakcích'),
				placeholder: placeholder,
				route: '/sm/transactions/list/search'
			},
			{
				code: 'archived_transactions',
				name: translationService.getString('v archivu transakcí'),
				placeholder: placeholder,
				route: '/sm/transactions/list/10',
				activeWhen: '/sm/transactions/list/10'
			},
			{
				code: 'offers',
				name: translationService.getString('v nabídkách'),
				placeholder: placeholder,
				route: '/sm/offers/list/search',
				activeWhen: '/sm/offers'
			},
			{
				code: 'templates',
				name: translationService.getString('v šablonách'),
				placeholder: placeholder,
				route: '/sm/templates/list/search',
				activeWhen: '/sm/templates'
			}
		];

		this.active = this.types[0];
	}

	selectType(type: GlobalSearchType) {
		this.active = type;
	}

	doSearch() {
		let url = this.active.route + '?query=' + encodeURIComponent(this.query.value);

		this._router.navigateByUrl(url);
		this.query.markAsPristine();
	}

	ngOnInit() {
		this._sub = this._router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				let end = event as NavigationEnd;
				let type = this.types.find(t => t.activeWhen && end.url.startsWith(t.activeWhen));
				if (type) {
					this.active = type;
				}
				else {
					this.active = this.types[0];
				}
			}
		});
	}

	ngOnDestroy() {
		this._sub.unsubscribe();
	}
}

class GlobalSearchType {
	code: string;
	name: string;
	placeholder: string;
	route: string;
	activeWhen?: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-global-search.component.ts